import CimsQuickLinkEntityTable from 'components/CIMSTable/common/components/CimsQuickLinkEntityTable'
import { Permission } from '@cims-online/shared'
import {
  useGetEjQuickLinksQuery,
  useCreateEjQuickLinkMutation,
  useEditEjQuickLinkMutation,
  useSoftRemoveEjQuickLinkMutation,
  useRestoreEjQuickLinkMutation,
} from 'schema'

const EJQuickLinks: React.FC = () => (
  <CimsQuickLinkEntityTable
    entity="Engineering Judgement"
    query={useGetEjQuickLinksQuery}
    getQuickLinks={(data) => data?.ejQuickLinks?.records ?? []}
    create={{
      permission: Permission.CreateEJQuickLink,
      mutation: useCreateEjQuickLinkMutation,
      getLabel: ({ createEJQuickLink: create }) => create.ejQuickLink,
    }}
    edit={{
      permission: Permission.EditEJQuickLink,
      mutation: useEditEjQuickLinkMutation,
      getLabel: ({ editEJQuickLink: edit }) => edit.ejQuickLink,
    }}
    remove={{
      permission: Permission.RemoveRestoreEJQuickLink,
      mutation: useSoftRemoveEjQuickLinkMutation,
      getLabel: ({ softRemoveEJQuickLink: remove }) => remove.ejQuickLink,
    }}
    restore={{
      permission: Permission.RemoveRestoreEJQuickLink,
      mutation: useRestoreEjQuickLinkMutation,
      getLabel: ({ restoreEJQuickLink: restore }) => restore.ejQuickLink,
    }}
  />
)

export default EJQuickLinks
